module.exports = __webpack_public_path__ + "img/dropdown-blue-arrow.914714b9.svg";